import { Grid } from '@mui/material'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useForm, FormProvider } from 'react-hook-form';
import { useLocation } from 'react-router';
import { RouterDOM, FnAxios, FnDialog, I18n, formatNumber } from 'utilities/utilities';
import { BtnBack, BtnDraft, BtnSave, BtnVersion } from 'components/Button/ButtonAll';
import { DatePickerItem } from 'components/Input/DatePicker/DatePickerItem';
import TableExpenseSection from './TableExpenseSection';
import moment from 'moment';
import _ from "lodash";
import { parseFloatCheckValue } from '../Ticket/fnTickit';
import { APIStatusCode, I18NextNs } from 'enum/enum';
import DialogRadioVersion from '../FundIncomePlan/DialogRadioVersion';
import DialogVersion from '../FundIncomePlan/DialogVersion';
import { TextBoxItem } from 'components/Input/TextBox';
import { GetMenuPermissionParamRoute } from 'utilities/SystemFunction';

export const ProviderExpensePlan = React.createContext(null);

const FundExpensesPlanForm = () => {
    //#region Hook
    const Router = RouterDOM();
    const AxiosFn = FnAxios()
    const DialogFn = FnDialog();
    const location = useLocation();
    // #endregion

    const objParamPath = useMemo(() => {
        const ParamId = new URLSearchParams(location.search).get("strParam");
        const ParamPrs = 2;
        return { ParamId, ParamPrs }
    }, [location.search])

    //#region State / Usememo
    const arrMonth = useMemo(() => ["ม.ค.", "ก.พ.", "มี.ค.", "รวม", "เม.ย.", "พ.ค.", "มิ.ย.", "รวม", "ก.ค.", "ส.ค.", "ก.ย.", "รวม", "ต.ค.", "พ.ย.", "ธ.ค.", "รวม", "รวมปีปฏิทิน"], [])
    const [isPermission, setIsPermission] = useState<boolean>(false);
    // const [isView, setIsView] = useState(false)
    const [modePlan, setModePlan] = useState("D")
    const [isVersion, setIsVersion] = useState(false)
    const [isOpenVersion, setIsOpenVersion] = useState(false)
    const [isOpenRadio, setIsOpenRadio] = useState(false)
    const [backupDataversion, setBackupDataversion] = useState([])

    const arrMock = useMemo(() => {
        return [
            {
                "name": "nM1",
                "nOrder": 1,
                "value": null
            },
            {
                "name": "nM2",
                "nOrder": 2,
                "value": null
            },
            {
                "name": "nM3",
                "nOrder": 3,
                "value": null
            },
            {
                "name": "nM4",
                "nOrder": 4,
                "value": null
            },
            {
                "name": "nM5",
                "nOrder": 5,
                "value": null
            },
            {
                "name": "nM6",
                "nOrder": 6,
                "value": null
            },
            {
                "name": "nM7",
                "nOrder": 7,
                "value": null
            },
            {
                "name": "nM8",
                "nOrder": 8,
                "value": null
            },
            {
                "name": "nM9",
                "nOrder": 9,
                "value": null
            },
            {
                "name": "nM10",
                "nOrder": 10,
                "value": null
            },
            {
                "name": "nM11",
                "nOrder": 11,
                "value": null
            },
            {
                "name": "nM12",
                "nOrder": 12,
                "value": null
            }
        ]
    }, [])

    const [lstExpense, setLstExpense] = useState([] as any)
    const [lstProject, setLstProject] = useState([] as any)
    const [lstSectionSummary, setLstSectionSummary] = useState([] as any)

    const [lstExpenseVersion, setLstExpenseVersion] = useState([] as any)
    const [lstProjectVersion, setLstProjectVersion] = useState([] as any)

    const [option, setOption] = useState({
        lstVersion: [],
    })

    // #endregion

    //#region Form
    const form = useForm({
        shouldFocusError: true,
        shouldUnregister: false,
        mode: "all",
        defaultValues: {
            dYear: null,
            sPlanDesc: null,
            sPlanDescVersion: null,
            isSaveVersion: null,
            lstExpensePlan: [] as any,
            lstExpensePlanVersion: [] as any
        }
    });
    // #endregion

    const getOptionInitialData = async () => {
        if (!objParamPath.ParamId) return;

        DialogFn.BlockUI();
        await AxiosFn.Get(`FundExpensePlan/GetFormInfoFundExpensePlan`, { sID: objParamPath.ParamId }, (result: { objResult: any; }) => {
            DialogFn.UnBlockUI();
            let objResult = result.objResult;
            if (objResult) {
                setModePlan(objResult.sMode)
                // setIsView(objResult.objIncome.sMode === "S")
                setOption(opt => ({
                    ...opt,
                    lstVersion: objResult.lstOptionversion,
                }))

                form.setValue("dYear", moment().set('year', objResult.nYear))
                form.setValue("sPlanDesc", objResult.sPlanDesc)
                form.setValue("lstExpensePlan", objResult.lstExpensePlanOnAdd)
                setLstExpense(objResult.lstMasterSection)
                setLstProject(objResult.lstProjectInSection)
                setLstSectionSummary(objResult.lstMasterSection)
            }
        }, null, () => DialogFn.UnBlockUI());
    };

    const handleSelectYear = async (eValue: moment.MomentInput) => {
        form.clearErrors();
        if (!eValue) {
            setLstExpense([])
            form.setValue("lstExpensePlan", [])
            setLstProject([])
            setLstSectionSummary([])
            return;
        }
        DialogFn.BlockUI();
        let nYear = parseInt(moment(eValue).format('YYYY'));
        await AxiosFn.Get(`FundExpensePlan/GetInitFormExpensePlan`, { nYear: nYear }, (result: { nStatusCode: number; objResult: any; }) => {
            DialogFn.UnBlockUI();
            if (result.nStatusCode === 203) {
                DialogFn.Warning("ข้อมูลประจำปี " + (nYear + 543) + " ได้ถูกบันทึกไปแล้ว");
                form.setValue("dYear", null)
                return;
            }

            let objResult = result.objResult;
            setLstExpense(objResult.lstMasterSection)
            form.setValue("lstExpensePlan", objResult.lstExpensePlanOnAdd)
            setLstProject(objResult.lstProjectInSection)
            setLstSectionSummary(objResult.lstMasterSection)

        }, null, () => DialogFn.UnBlockUI());
    };

    const handleSelectVersion = (result: any) => {
        setIsVersion(true)
        let cloneDeep = _.cloneDeep(form.getValues("lstExpensePlan"))
        setBackupDataversion(cloneDeep)

        form.setValue("sPlanDescVersion", result.sPlanDesc)
        form.setValue("lstExpensePlanVersion", result.lstExpensePlanOnAdd)
        setLstExpenseVersion([...result.lstMasterSection])
        setLstProjectVersion([...result.lstProjectInSection])
        setLstSectionSummary([...result.lstMasterSection])
        form.reset({
            ...form.watch(),
        });
        setIsOpenVersion(false)

    }

    const handleSubmitForm = (sMode: string) => {
        if (sMode === "S") {
            // Check section 5 equsl input ?
            let nInputSection = lstExpense.find((f: { nSectionId: number; }) => f.nSectionId === 39)?.nTotalInput ?? 0;

            // let nTotalInput = parseFloatCheckValue(form.getValues("inputTotal_39_4"));
            let sumTotal = _.sumBy(form.getValues("lstExpensePlan"), function (o: any) { return parseFloatCheckValue(o.nTotal); });
            if (sumTotal !== nInputSection) {
                let diff = formatNumber(nInputSection - sumTotal, 2);
                DialogFn.Warning("ไม่สามารถกดยืนยันได้ เนื่องจากผลรวมของมาตรา 40(5) เทียบกับวงเงินทั้งหมดของมาตรา 40(5) ไม่เท่ากัน โดยมีส่วนต่าง " + diff);
                return;
            }

            if (objParamPath.ParamId && modePlan !== "D") {
                setIsOpenRadio(true)
            } else {
                handleSubmitExpensePlan("S")
            }

            return;
        }
        form.clearErrors();
        handleSubmitExpensePlan("D")
    }

    const handleSubmitExpensePlan = (sMode: string) => {

        let objParam = {
            "sMode": sMode,
            "sID": objParamPath.ParamId,
            "sPlanDesc": form.getValues("sPlanDesc"),
            "isSaveVersion": form.getValues("isSaveVersion") === "1",
            "nYear": form.getValues("dYear") ? parseInt(moment(form.getValues("dYear")).format('YYYY')) : null,
            "lstExpenseSection": lstExpense,
            "lstProjectSection": lstProject,
            "lstExpensePlanAdd": form.getValues("lstExpensePlan") || []
        }

        DialogFn.Submit(I18n.SetText("Message.ConfirmSave", I18NextNs.labelComponent), () => {
            AxiosFn.Post(`FundExpensePlan/OnSubmitFundExpensePlan`, objParam, (result: { nStatusCode: number; sMessage: any; }) => {
                if (result.nStatusCode === APIStatusCode.Success) {
                    DialogFn.Success(I18n.SetText("Message.SaveComplete", I18NextNs.labelComponent), () => {
                        gotoBack();
                    });
                } else {
                    DialogFn.Warning(result.sMessage);
                }
            });
        });
    }

    const calIndexOld = (index: number) => {
        if (index === 2) {
            return 1
        }
        else if (index === 5) {
            return 2
        }
        else if (index === 8) {
            return 3
        }
        return 4
    }

    const findMaxID = useCallback(() => {
        const lstExpensePlan = form.watch(`lstExpensePlan`);
        let arrInt = [] as any;
        lstExpensePlan.forEach((element: { nID: any; lstSubLevel: any; }) => {
            arrInt.push(element.nID)
            RecursiveGetID(element.lstSubLevel);

            function RecursiveGetID(children: any[]) {
                if (children) {
                    children.forEach((elementChild: { nID: any; lstSubLevel: any; }) => {
                        arrInt.push(elementChild.nID);
                        RecursiveGetID(elementChild.lstSubLevel);
                    });
                }
            }
        });
        let nIDMax = arrInt.length > 0 ? (Math.max(...arrInt)) + 1 : 1
        return nIDMax;
    }, [form])


    const gotoBack = () => {
        if (isVersion) {
            setIsVersion(false)
            form.setValue("lstExpensePlan", backupDataversion)
            setLstExpense(value => [...value])
            setLstProject(value => [...value])
            setLstSectionSummary(value => [...value])
            form.reset({
                ...form.watch(),
            });
            return;
        }
        Router.GoToPage("/FundExpensePlanList")
    }

    const lstSummary = React.useMemo(() => {
        let lstSummary = _.cloneDeep(lstSectionSummary);
        let lstExpensePlan = isVersion ? form.getValues(`lstExpensePlanVersion`) : form.getValues(`lstExpensePlan`);
        lstSectionSummary.forEach((element: { nSectionId: number; sSectionName: string; nQ1: any; nQ2: any; nQ3: any; nQ4: any; nTotal: any; lstExpenseMonth: any[]; }) => {
            if (element.nSectionId === 39) {
                element.nQ1 = _.sumBy(lstExpensePlan, (item: any) => _.get(item, 'nQ1', 0));
                element.nQ2 = _.sumBy(lstExpensePlan, (item: any) => _.get(item, 'nQ2', 0));
                element.nQ3 = _.sumBy(lstExpensePlan, (item: any) => _.get(item, 'nQ3', 0));
                element.nQ4 = _.sumBy(lstExpensePlan, (item: any) => _.get(item, 'nQ4', 0));
                element.nTotal = _.sumBy(lstExpensePlan, (item: any) => _.get(item, 'nTotal', 0));
                element.lstExpenseMonth.forEach((eleInput: { nOrder: number; value: any; }) => {
                    let sPathValue = `lstExpenseMonth[${eleInput.nOrder - 1}].value`;
                    eleInput.value = _.sumBy(lstExpensePlan, (item: any) => _.get(item, sPathValue, 0));
                });
            }
            else {
                let lstDataSectionProject = lstProject.filter((f: { nSectionId: any; }) => f.nSectionId === element.nSectionId);
                element.nQ1 = _.sumBy(lstDataSectionProject, (item: any) => _.get(item, 'nQ1', 0));
                element.nQ2 = _.sumBy(lstDataSectionProject, (item: any) => _.get(item, 'nQ2', 0));
                element.nQ3 = _.sumBy(lstDataSectionProject, (item: any) => _.get(item, 'nQ3', 0));
                element.nQ4 = _.sumBy(lstDataSectionProject, (item: any) => _.get(item, 'nQ4', 0));
                element.nTotal = _.sumBy(lstDataSectionProject, (item: any) => _.get(item, 'nTotal', 0));
                element.lstExpenseMonth.forEach((eleInput: { nOrder: number; value: any; }) => {
                    let sPathValue = `lstExpenseMonth[${eleInput.nOrder - 1}].value`;
                    eleInput.value = _.sumBy(lstDataSectionProject, (item: any) => _.get(item, sPathValue, 0));
                });
            }
        });


        return lstSummary;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lstSectionSummary, lstProject, form.getValues(`lstExpensePlan`), form.getValues(`lstExpensePlanVersion`)])

    const objExpenseProvider = React.useMemo(() => (
        {
            arrMonth,
            arrMock,
            isView: !isPermission,
            form,
            lstExpense,
            setLstExpense,
            lstProject,
            setLstProject,
            calIndexOld,
            lstSectionSummary,
            setLstSectionSummary,
            findMaxID,
            lstSummary,
            isVersion,
            lstExpenseVersion,
            lstProjectVersion
        }
    ), [arrMonth, arrMock, isPermission, form, lstExpense, lstProject, lstSectionSummary, findMaxID, lstSummary, isVersion, lstExpenseVersion, lstProjectVersion]);

    useEffect(() => {
        GetMenuPermissionParamRoute("/FundExpensePlanList", AxiosFn, setIsPermission, DialogFn);
        getOptionInitialData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        let lstExpensePlan = isVersion ? form.getValues(`lstExpensePlanVersion`) : form.getValues(`lstExpensePlan`);
        lstSectionSummary.forEach((element: { nSectionId: number; nQ1: any; nQ2: any; nQ3: any; nQ4: any; nTotal: any; lstExpenseMonth: any[]; }) => {
            if (element.nSectionId === 39) {
                element.nQ1 = _.sumBy(lstExpensePlan, (item: any) => _.get(item, 'nQ1', 0));
                element.nQ2 = _.sumBy(lstExpensePlan, (item: any) => _.get(item, 'nQ2', 0));
                element.nQ3 = _.sumBy(lstExpensePlan, (item: any) => _.get(item, 'nQ3', 0));
                element.nQ4 = _.sumBy(lstExpensePlan, (item: any) => _.get(item, 'nQ4', 0));
                element.nTotal = _.sumBy(lstExpensePlan, (item: any) => _.get(item, 'nTotal', 0));
                element.lstExpenseMonth.forEach((eleInput: { nOrder: number; value: any; }) => {
                    let sPathValue = `lstExpenseMonth[${eleInput.nOrder - 1}].value`;
                    eleInput.value = _.sumBy(lstExpensePlan, (item: any) => _.get(item, sPathValue, 0));
                });
            }
            else {
                let lstDataSectionProject = lstProject.filter((f: { nSectionId: any; }) => f.nSectionId === element.nSectionId);
                element.nQ1 = _.sumBy(lstDataSectionProject, (item: any) => _.get(item, 'nQ1', 0));
                element.nQ2 = _.sumBy(lstDataSectionProject, (item: any) => _.get(item, 'nQ2', 0));
                element.nQ3 = _.sumBy(lstDataSectionProject, (item: any) => _.get(item, 'nQ3', 0));
                element.nQ4 = _.sumBy(lstDataSectionProject, (item: any) => _.get(item, 'nQ4', 0));
                element.nTotal = _.sumBy(lstDataSectionProject, (item: any) => _.get(item, 'nTotal', 0));
                element.lstExpenseMonth.forEach((eleInput: { nOrder: number; value: any; }) => {
                    let sPathValue = `lstExpenseMonth[${eleInput.nOrder - 1}].value`;
                    eleInput.value = _.sumBy(lstDataSectionProject, (item: any) => _.get(item, sPathValue, 0));
                });
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lstSectionSummary, lstExpense, lstProject, form.getValues(`lstExpensePlan`), form.getValues(`lstExpensePlanVersion`)])

    return (
        <ProviderExpensePlan.Provider value={objExpenseProvider} >
            <FormProvider {...form}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Grid
                            container
                            spacing={2}
                            justifyContent={"space-between"}
                            alignItems={"start"}
                        >
                            <Grid item xs={12} sm={12} md={7}>
                                <Grid
                                    container
                                    spacing={2}
                                >
                                    <Grid item xs={12} sm={12} md={4}>
                                        <DatePickerItem
                                            id={`dYear`}
                                            name={`dYear`}
                                            label={`ประจำปี`}
                                            required
                                            fullWidth
                                            disabled={isVersion || !isPermission || !!objParamPath.ParamId}
                                            IsYearPicker
                                            format='YYYY'
                                            onChange={(eValue) => handleSelectYear(eValue)}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={8}>
                                        <TextBoxItem
                                            name="sPlanDescVersion"
                                            label="ประชุมครั้งที่"
                                            required={false}
                                            maxLength={50}
                                            disabled={true}
                                            style={{
                                                display: !isVersion ? "none" : ""
                                            }}
                                        />
                                        <TextBoxItem
                                            name="sPlanDesc"
                                            label="ประชุมครั้งที่"
                                            required={false}
                                            maxLength={50}
                                            disabled={!isPermission}
                                            style={{
                                                display: isVersion ? "none" : ""
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={"auto"}>
                                {
                                    isPermission && modePlan !== "D" && option.lstVersion.length !== 0 ?
                                        <BtnVersion id={"btnversion"} onClick={() => setIsOpenVersion(true)} />
                                        : null
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                    {lstExpense.length === 0 ?
                        <Grid item xs={12}>
                            <Grid container justifyContent={"center"} >
                                <Grid item >
                                    ไม่พบข้อมูล
                                </Grid>
                            </Grid>
                        </Grid>
                        :
                        <Grid item xs={12}>
                            <TableExpenseSection />
                        </Grid>
                    }

                    <Grid item xs={12}>
                        <Grid
                            container
                            spacing={2}
                            justifyContent={"space-between"}
                            alignItems={"start"}
                        >
                            <Grid item>
                                <BtnBack id={"btnback"} onClick={() => gotoBack()} />
                            </Grid>
                            <Grid item>
                                {
                                    !isPermission || isVersion || lstExpense.length === 0 ? null :
                                        <Grid
                                            container
                                            spacing={2}
                                            justifyContent={"end"}
                                            alignItems={"start"}
                                        >
                                            {modePlan === "D" && <Grid item>
                                                <BtnDraft
                                                    id={"btndraft"}
                                                    onClick={() => handleSubmitForm("D")}
                                                />
                                            </Grid>}
                                            <Grid item>
                                                <BtnSave
                                                    id={"btnsave"}
                                                    onClick={form.handleSubmit(() => handleSubmitForm("S"))}
                                                />
                                            </Grid>
                                        </Grid>
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <DialogRadioVersion
                    isOpenRadio={isOpenRadio}
                    setIsOpenRadio={setIsOpenRadio}
                    form={form}
                    handleSubmit={handleSubmitExpensePlan}
                />
                <DialogVersion
                    isOpenVersion={isOpenVersion}
                    setIsOpenVersion={setIsOpenVersion}
                    nYear={form.getValues("dYear")}
                    option={option.lstVersion}
                    handleSelectVersion={handleSelectVersion}
                    isInCome={false}
                />
            </FormProvider>

        </ProviderExpensePlan.Provider>
    )
}

export default FundExpensesPlanForm